import { supportTabs } from '../constants'

function getServiceListVm (vm) {
  return vm.list || (vm.params && vm.params.list) || null
}

export default {
  created () {
    this.singleActions = [
      {
        label: this.$t('system.service_update_config'),
        action: (obj) => {
          this.createDialog('ServiceConfigUpdateDialog', {
            vm: this,
            data: [obj],
            refresh: () => {
              const list = getServiceListVm(this)
              if (list && typeof list.fetchData === 'function') {
                list.fetchData()
              }
              if (typeof this.fetchData === 'function') {
                this.fetchData()
              }
              // 侧滑页 mixin 会监听该事件并 singleRefresh，重新拉取 services/:id/config 等详情数据
              if (this.$bus && typeof this.$bus.$emit === 'function') {
                this.$bus.$emit('refresh-detail')
              }
            },
          })
        },
        meta: (obj) => {
          const serviceName = obj?.name
          const conf = supportTabs.find(item => item.name === serviceName)
          return {
            // 根据 supportTabs.config 控制是否允许修改配置
            validate: conf ? !!conf.config : false,
          }
        },
      },
    ]
  },
}
